import { Tabs, TabsList } from "@nexus/ui"
import { useTranslation } from "react-i18next"
import type { OpportunityTabCounts, OpportunityTabKey } from "../../../types/opportunities.types"

export interface OpportunitiesStatusTabsProps {
  counts: OpportunityTabCounts
  activeTab: OpportunityTabKey
  onTabChange: (tab: OpportunityTabKey) => void
}

const tabKeys: OpportunityTabKey[] = ["active", "completed_scripts", "rejected"]

const tabI18nMap: Record<OpportunityTabKey, string> = {
  active: "opportunities.tabs.active",
  completed_scripts: "opportunities.tabs.completedScripts",
  rejected: "opportunities.tabs.rejected",
}

export function OpportunitiesStatusTabs({ counts, activeTab, onTabChange }: OpportunitiesStatusTabsProps) {
  const { t } = useTranslation()

  const visibleTabs = tabKeys.filter((key) => key === activeTab || key === "completed_scripts" || key === "rejected" || counts[key] > 0)

  return (
    <Tabs value={activeTab} onValueChange={(v) => onTabChange(v as OpportunityTabKey)}>
      <TabsList
        variant="line"
        options={visibleTabs.map((key) => ({
          value: key,
          label: t(tabI18nMap[key]),
          badge: counts[key],
        }))}
      />
    </Tabs>
  )
}
